import React from 'react';
import { Button } from '@/components/ui/button';
import { SearchX } from 'lucide-react';

interface NoResultsMessageProps {
  onClearSearch: () => void;
  hasSearchQuery?: boolean;
}

export const NoResultsMessage: React.FC<NoResultsMessageProps> = ({
  onClearSearch,
  hasSearchQuery = false,
}) => {
  return (
    <div className='flex flex-col items-center justify-center py-8 px-4 text-center'>
      <SearchX className='h-12 w-12 text-muted-foreground mb-4' />
      <h3 className='text-lg font-medium text-foreground mb-2'>
        {hasSearchQuery ? 'No nodes found' : 'No nodes available'}
      </h3>
      <p className='text-sm text-muted-foreground mb-4'>
        {hasSearchQuery
          ? 'Try adjusting your search terms or clear the search to see all nodes.'
          : 'There are no nodes available at the moment.'}
      </p>
      {hasSearchQuery && (
        <Button variant='outline' onClick={onClearSearch}>
          Clear Search
        </Button>
      )}
    </div>
  );
};
